import { buildSlice, SignalChartState } from './slice';

const slice = buildSlice((state: { signal: SignalChartState }) => state.signal);

export default slice;
export const selectors = slice.selectors;
